import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const LoadingPlaceholder = () => {
  return <SkeletonBlock $width="150px" $height="20px" />;
};
